import { Controller } from "@hotwired/stimulus"

// chart-map-sync — MVP one-way URL hash sync between UI-04 chart and UI-05 map.
//
// Map marker click → CustomEvent("map:click", {detail: {timestamp}})
//                  → window.location.hash = "t=<unix_ts>"
//
// The UI-04 chart page (separate URL, Plan 04-08) can read window.location.hash
// on load to scroll/annotate to that timestamp. Bidirectional sync (chart hover
// → map highlight) is deferred to the split-pane milestone (RESEARCH §Open
// Question 3, UI-SPEC §Chart-Map Sync MVP scope).
//
// Auto-registered via `controllers/index.js` esbuild glob.
export default class extends Controller {
  connect() {
    this.boundMapClick = this.handleMapClick.bind(this)
    this.element.addEventListener("map:click", this.boundMapClick)
  }

  disconnect() {
    this.element.removeEventListener("map:click", this.boundMapClick)
  }

  handleMapClick(event) {
    const ts = event.detail?.timestamp
    if (ts) window.location.hash = `t=${ts}`
  }
}
